export const factory_1_kr = "경기도 하남시 풍산동 489 미사테스타타워 FB329호, FB330호, FB331호, FB332호";
export const factory_1_en = "​FB329, FB330, FB331, FB332, 25, Misagangbyeonseo-ro, Hanam-si, Gyeonggi-do, Republic of Korea";
export const factory_2_kr = "서울특별시 성동구 성수일로 99 서울숲에이케이밸리지식산업센터 지하2층 비206,207호";
export const factory_2_en = "B206,207 99, Seongsuil-ro, Seongdong-gu, Seoul, Republic of Korea";
export const address_lab_kr = "경기도 하남시 풍산동 595-1, 595-2 A동 408호";
export const address_brand_kr = "서울시 성수동 성수일로 55 SK테크노빌딩 806호";
